 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"aicustomized~package":"aicustomized~package","aicustomized":"aicustomized","package":"package","user":"user","ai-assistant":"ai-assistant","report":"report","family":"family","goods":"goods","greenway":"greenway","health":"health","healthInsurance":"healthInsurance","medical":"medical","notice":"notice","oppo-package":"oppo-package","order":"order","org":"org","pdfjsWorker":"pdfjsWorker","rights":"rights"}[chunkId]||chunkId) + "." + {"aicustomized~package":"a5e71a76","aicustomized":"bce8e51f","package":"c3e799e7","chunk-141709b3":"3e0d3a60","chunk-18b90d1c":"ced446da","chunk-3897a6ca":"a05c8b91","chunk-3921d1c6":"2734aa35","chunk-3d35c898":"0c8efcda","chunk-47290efa":"587c990c","chunk-501ffe5a":"97de7b8a","chunk-540575bc":"5f3bc072","chunk-5be673b3":"dd95572c","chunk-5c326760":"65f21d0b","chunk-1aa1d28c":"7c1c6369","chunk-69ac8fe4":"1e7259fc","user":"63f86964","chunk-a0e92ac6":"d8eb25d5","chunk-40483717":"f560aef2","ai-assistant":"dac560e2","chunk-41c2028e":"6d6c6378","chunk-478de8fc":"b5679195","chunk-53e8ef43":"727b78f4","chunk-872a6020":"ee0ed41d","report":"c82b3370","chunk-ac57440a":"335a138c","chunk-b7911cb2":"99c4f428","chunk-cb3fb368":"5b367be1","chunk-f8a66012":"a7be541b","family":"af266f1a","goods":"36814d30","greenway":"edef02d8","health":"f97dd198","healthInsurance":"7169e8cc","medical":"a47ca2c6","notice":"c51098a3","oppo-package":"a8e7cfe4","order":"18d22276","org":"ce38821e","pdfjsWorker":"dd4ec650","rights":"5f0c4640"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"aicustomized~package":1,"aicustomized":1,"package":1,"chunk-141709b3":1,"chunk-18b90d1c":1,"chunk-3897a6ca":1,"chunk-3921d1c6":1,"chunk-3d35c898":1,"chunk-47290efa":1,"chunk-501ffe5a":1,"chunk-540575bc":1,"chunk-5be673b3":1,"chunk-5c326760":1,"chunk-1aa1d28c":1,"chunk-69ac8fe4":1,"user":1,"chunk-a0e92ac6":1,"chunk-40483717":1,"ai-assistant":1,"chunk-41c2028e":1,"chunk-478de8fc":1,"chunk-53e8ef43":1,"chunk-872a6020":1,"report":1,"chunk-ac57440a":1,"chunk-b7911cb2":1,"chunk-cb3fb368":1,"chunk-f8a66012":1,"family":1,"goods":1,"greenway":1,"health":1,"healthInsurance":1,"medical":1,"notice":1,"oppo-package":1,"order":1,"org":1,"rights":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"aicustomized~package":"aicustomized~package","aicustomized":"aicustomized","package":"package","user":"user","ai-assistant":"ai-assistant","report":"report","family":"family","goods":"goods","greenway":"greenway","health":"health","healthInsurance":"healthInsurance","medical":"medical","notice":"notice","oppo-package":"oppo-package","order":"order","org":"org","pdfjsWorker":"pdfjsWorker","rights":"rights"}[chunkId]||chunkId) + "." + {"aicustomized~package":"dadd465e","aicustomized":"5a548bdc","package":"51711831","chunk-141709b3":"05ae6422","chunk-18b90d1c":"3ccf61a7","chunk-3897a6ca":"900d9426","chunk-3921d1c6":"dfe1e43a","chunk-3d35c898":"1b523ab7","chunk-47290efa":"d43feaeb","chunk-501ffe5a":"7c8b5a16","chunk-540575bc":"91dde842","chunk-5be673b3":"deec3f89","chunk-5c326760":"cbbab3a6","chunk-1aa1d28c":"d38ef30b","chunk-69ac8fe4":"d9f780b7","user":"67a7e730","chunk-a0e92ac6":"67939817","chunk-40483717":"c5b9cd31","ai-assistant":"d41cc03f","chunk-41c2028e":"6eb1264f","chunk-478de8fc":"cb3b19fb","chunk-53e8ef43":"cf0f9165","chunk-872a6020":"a489dc56","report":"aaafd194","chunk-ac57440a":"17afce6e","chunk-b7911cb2":"36c1fe8c","chunk-cb3fb368":"3a3c3381","chunk-f8a66012":"7f435d11","family":"b905ef30","goods":"4f518018","greenway":"a8b40211","health":"089ab1ed","healthInsurance":"262c5652","medical":"fba2cffd","notice":"18bcc494","oppo-package":"aa50c77b","order":"9ad57322","org":"eb655288","pdfjsWorker":"31d6cfe0","rights":"c89327eb"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
